import React from "react";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import Head from "next/head";
// import ManageBooking from '../../manage-booking/ManageBooking';

const TermsAndCondition: React.FC = () => {
  // const [openBookingRefModal, setOpenBookingRefModal] = useState(false);

  return (
    <>
      <Head>
        <title style={{ color: "#060273" }}>Terms & Conditions | World Cruise Vibes</title>
        <meta name="title" content="Terms & Conditions | World Cruise Vibes" />
        <meta
          name="description"
          content="Thank you for choosing World Cruise Vibes, Please read our terms & conditions to ensure that you have an enjoyable and trouble-free holiday."
        />
      </Head>
      <Box
        sx={{
          mt: "3.5rem",
          a: {
            color: "primary.main",
            fontSize: { xs: "0.9rem", sm: "1rem" },
          },
          h4: {
            fontSize: "18px",
            mt: "24px",
          },
          ol: {
            mb: "1rem",
            fontSize: { xs: "0.9rem", sm: "1rem" },
          },
          ul: {
            mb: "1rem",
            pl: { xs: "1rem", md: "2.5rem" },
            listStyle: "circle",
            fontSize: { xs: "0.9rem", sm: "1rem" },
          },
          p: {
            fontSize: { xs: "0.9rem", sm: "1rem" },
          },
          ".MuiTypography-body1": {
            fontSize: { xs: "0.9rem", sm: "1rem" },
          },
        }}
      >
        <Typography
          variant="h3"
          component={"h2"}
          color="primary"
          sx={{
            mt: "1rem",
            mb: "2rem",
            fontSize: {
              xs: "1.6rem",
              sm: "2rem",
              md: "2rem",
              lg: "2rem",
            },
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          World Cruise Vibes Terms and Conditions
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          1. INTRODUCTION
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          1.1. These terms and conditions, our{" "}
          <Link href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </Link>
          , and any other information we brought to your attention before we confirmed your booking,
          apply to your booking with World Cruise Vibes Ltd, with registered office at 14
          Cricklewood Ln, London NW2 1EX, United Kingdom (“we”, “us” or “our”). Please read them
          carefully and accept them in full prior to booking. In these terms and conditions,
          references to “you” or “your” includes the customer on the booking and all persons on
          whose behalf a booking is made or to any other person a booking is added or transferred.
          If you have any additional questions after reading these terms and conditions, please do
          not hesitate to contact our customer service staff, who will be happy to assist you.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          1.2. We are merely acting as an agent or sub-agent of the service provider, except where
          we state the contrast of these terms and conditions. When you are making a booking on our
          platform, our service is only to receive and provide information about those travel
          services, and you will enter into a contract with the service provider of the travel
          service. Our conditions to you may vary depending upon which arrangements you book with
          us, and we set them out clearly at the end of this document.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          2. COVID-19 AND ENTRY REGULATIONS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.1. We both acknowledge and agree that the COVID-19 pandemic has affected travel
          throughout the world and that we have responsibilities to comply with various laws,
          regulations and guidance issued by governmental or regulatory authorities. It is a
          condition of making your booking through us that you obtain travel insurance which
          includes cover against any issues or incidents which may affect your booking.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.2. You may be required to undergo temperature checks, provide health information or
          certificates, wear personal protective equipment such as face masks and gloves and abide
          by social distancing requirements. There may also be other limitations on the number of
          persons who may use facilities or services at any particular time.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.3. It is your responsibility to accept that certain Service Providers, ports, airports,
          border control or other third parties may need you and members of your party to perform
          certain health formalities. If you fail to meet these requirements or refuse to complete
          them, you may be denied boarding, exit, entry or the use of some other facility or
          service.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.4. Some countries may impose quarantine or self-isolation measures upon travellers,
          whether in the place of destination or upon return. It is essential that you strongly
          familiarise yourself with the advice from your national authority for overseas travel
          before departing. In the UK, the Foreign and Commonwealth Office&apos;s latest advice for
          travel to other countries is available on the link below.{" "}
          <a
            href="https://www.gov.uk/browse/abroad/travel-abroad"
            target={"_blank"}
            rel="noreferrer"
          >
            https://www.gov.uk/browse/abroad/travel-abroad
          </a>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.5. Please note that we will issue no refunds for the fees you have paid for vaccination
          and quarantine requirements at your destination if those procedures are not carried out by
          the time you visit. (e.g., if you booked your holiday with us months prior to your actual
          departure date, and if, by the time you travel, COVID-19 regulations are lifted and you
          will not need to undergo quarantine requirements, no refunds will be issued).
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.6. In the circumstances where you advise us before travelling and the relevant Service
          Providers, or we decide that you are no longer able to travel because of the COVID-19
          risk, then your booking will be handled as having been cancelled. Nevertheless, there will
          be options to explore with you whether you can postpone your booking to a later date.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.7. While travelling, it is required that you acknowledge that Service Providers (or
          local laws and regulations or health and safety bodies) or we may require you to follow
          several measures intended to handle the risk of COVID-19. You may be obliged to
          self-isolate for some time, and you agree to comply with these requirements.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.8. We have no accountability to you or any member of your party for any refunds,
          compensation, losses, costs, expenses, or damages you incur in conjunction with the
          matters specified above or if you are unable to travel. These are risks which you must
          protect against by purchasing comprehensive travel insurance.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          2.9. You acknowledge that due to the impact of COVID-19, many hotels are closing on short
          notice or making adjustments to their facilities to ensure the safety of employees and
          travellers. Where a hotel closure affects your booking, we will arrange alternative
          accommodation for you to enable your holiday to continue.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          3. PACKAGE HOLIDAY
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          3.1. Many of the arrangements which we help you organise result into &quot;Packages&quot;,
          as this word is defined in the Package Travel and Linked Travel Arrangements Regulations
          2018 (“Package Travel Regulations”). A Package will exist if you are resident within the
          European Economic Area (EEA) and you book a combination of at least two of the following
          Travel Services in a single booking with us, where the arrangement covers a period of more
          than 24 hours or includes overnight accommodation.
        </Typography>
        <Typography component={"ul"}>
          <li>Transport</li>
          <li>Accommodation</li>
          <li>Hire of motor vehicles</li>
          <li>Other tourist services</li>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          In the case of where you are buying a mixture which involves &apos;other tourist
          services&apos; and only one of (a), (b) or (c) above, then this will only be a Package if
          the &apos;other tourist services&apos;;
        </Typography>
        <Typography component={"ul"}>
          <li>Are not necessary to (a), (b) or (c) above.</li>
          <li>Are not bought after the start of the performance of (a), (b) or (c) above and</li>
          <li>
            If unless it accounts for a vital proportion of the value of the Package, or otherwise
            serves an essential feature of the Package.
          </li>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          Meanwhile, once you book a Package, we will continuously be acting as an agent or
          sub-agent in the way described above. For this reason, you will still be entering into
          different contracts with the Service Provider(s) or principal supplier(s) of each specific
          Travel Service. This is regarded as a “Multi-Contract Package” in your ATOL Certificate.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          3.2. Please understand that Packages on our site are not identical to conventional
          pre-packaged holidays where the Travel Services are customarily pre-selected by a tour
          operator or travel company. Through our booking platform, you will be responsible to
          select each Travel Service yourself. Together, your selections and contracts with the
          Service Providers form a Package.
          <br />
          However, because we help you organise the Package, the Package Travel Regulations (PTR)
          require us to assist you in specific situations, which we will do as outlined in these
          Terms and Conditions.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          4. BOOKING AND PAYMENT
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.1. When making a booking with us, you must be over 18 years of age, and when placing an
          order for services with age restrictions, you certify that you and members of your party
          are of the appropriate age of purchase for those services.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.2. When making a booking, all passenger details should be complete and accurate. If you
          believe that any detail on the booking summary is wrong, you must advise us immediately as
          it may not be possible to make changes later. You may incur charges to make changes that
          may harm your rights if we are not notified of any errors in any document immediately.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.3. It is your responsibility to review all dates, names, and timings, are accurate on
          receipt of all documents and notify us of any errors immediately. We do not charge for any
          changes that occur to the documents; however, you will have to pay any charges made by the
          relevant service providers. Please ensure that the names provided are identical to the
          names on relevant passports.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.4. We accept payment by debit/credit card (Visa, MasterCard, Maestro and American
          Express). We do not charge you a fee for using your card; however, your bank or card
          issuer may apply an additional foreign transaction fee for non-UK registered cards.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.5. In some instances, we may be able to use vouchers/loyalty points issued to you by
          Service Providers towards payment of your booking. Cards and vouchers (where appropriate)
          accepted are subject to security and fraud checks. We, the travel company, reserve the
          right to reject/cancel your Travel Service(s) should your booking request fail any
          component of these checks.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.6. Booking requests can take up to 72 hours to process. A booking is only confirmed when
          we send you a Booking Confirmation. On rare occasions, we will be unable to confirm a
          booking, for example if the payment fails. Any cost increases will need to be paid by you,
          as per your contract with each Service Provider.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.7. At the time of booking, you will be required to pay a deposit or the full amount of
          your booking. You must pay the complete balance by the balance due date notified to you if
          you only pay a deposit.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.8. We will attempt to take all payments automatically from the same credit/debit card
          used to pay the initial deposit. If you need to arrange for the remainder of the
          instalments to be collected from a different card, please notify us at{" "}
          <a href="mailto:collections@worldcruisevibes.com" target={"_blank"} rel="noreferrer">
            collections@worldcruisevibes.com.
          </a>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          4.9. Payment options are subject to availability, and we reserve the right to end any such
          offers at any time without prior notice or explanation.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          5. PRICES AND PRICING ERRORS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          5.1. We Strive to guarantee that all pricing and any additional information on our website
          are accurate. We and each Service Provider reserve the right to amend the advertised price
          at any time before confirmation.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          5.2. In the circumstances where a pricing or other error is obvious, we may terminate the
          contract and refund you any sums you have paid us.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          5.3. If the price of your package is increased, then you may;
        </Typography>
        <Typography component={"ul"}>
          <li>Accept and pay for the price increase.</li>
          <li>Reject the price increase and terminate your package with a full refund.</li>
          <li>
            Refuse the price increase, cancel your package, and take an alternative one if we decide
            to offer this.
          </li>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          5.4. We will give you a justifiable period of time to make your decision, which will
          usually be 2 days from the notification of the price increase.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          5.5. You will be entitled to a price reduction for your package booking corresponding to
          any decrease in the costs described above after you have booked out before the start of
          your package.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          Please note that if there are any alterations in the prices due to factors such as fuel
          surcharge or other power sources, exchange rates, the amounts that you may have already
          paid us in advance as well as taxes or fees imposed by third parties might subject to
          change. This is because we hold your reservations at the time of booking and if any
          changes happen between the period you booked with us and the final payment, you have to
          pay any additional charges made by the relevant service providers for holding your
          reservation.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          6. PAYMENT OPTIONS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          6.1. At the time of booking, you will be required to pay a deposit or the full amount of
          your booking. You must pay the complete balance by the Balance Due Date notified to you if
          you only pay a deposit.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          6.2. We will attempt to take all payments automatically from the same credit/debit card
          used to pay the initial deposit. If you need to arrange for the remainder of the
          instalments to be collected from a different card, please notify us at{" "}
          <a href="mailto:collections@worldcruisevibes.com." target={"_blank"} rel="noreferrer">
            collections@worldcruisevibes.com.
          </a>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          6.3. There will be some circumstances where Service Providers will provide instalment
          plans and low deposit options for payment which can be used for your booking. The complete
          details will be presented, including payment dates, at the time of booking.
          <br />
          <b>Low Deposits:</b> The first low deposit is due per person and will be presented at the
          time of booking. After that, depending on the Travel Service(s) you have chosen, we will
          attempt to automatically take the pending second deposit from the same credit/debit card
          used to pay the initial deposit. You will be informed of the due date before booking. In
          the event of cancellation before the due date of the second deposit, you will remain
          liable for the total deposit amount. (i.e., both the first and second deposit.)
          <br />
          <b>Pay Monthly:</b> Should you decide on the monthly payment plan, after payment of the
          deposit, we will attempt to take the remaining balance in monthly instalments, with the
          final payment being taken on the date specified in your Booking Confirmation before your
          departure. In the event of cancellation after the second instalment, we/the Service
          Providers reserve the right to keep all payments made by you to date to cover
          administration charges.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          6.4. Payment options are subject to availability, and we reserve the right to end any such
          offers at any time without prior notice or explanation.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          7. FLIGHTS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          7.1. While searching for and booking a flight, we will act as your booking agent on the
          criteria designated by you. On these terms, we shall arrange for you to enter into a
          contract directly with the airline and with us. Some airlines will use the payment
          information provided by you to book the flight seats you require on their behalf.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          7.2. We accept no liability concerning any contract you enter into with the airline or
          their acts or omissions. Before requesting that we book your flight, you should read these
          attentively. You specifically agree to the conditions of this passage by making a booking
          for which we are acting as your agent.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          7.3. Where applicable, monies paid to us for such flight services are held by us on your
          behalf until they are paid to the airline in question. Please note that payment by you to
          us does not constitute payment to the airline until we make that payment on your behalf,
          but if we collect monies from the airline on your behalf, their liability to pay that
          money to you is discharged.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          <b>7.4. Charter flights:</b> When you book your charter flight through us, we act as
          agents for the charter flight provider who holds an ATOL. The contract will be between you
          and the charter flight provider based upon their terms and conditions, a copy of which
          will be available to you prior to booking and is available on request.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          <b>7.5. IATA flights:</b> We are appointed by some airlines as their agent through our
          accreditation with the International Air Transport Association (IATA). Where you book
          these flights through our platform, we will be acting as an agent for the relevant
          airline.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          <b>7.6. Operating Carrier Information:</b> In accordance with EU directive (EC) no.
          2111/2005, Article 9, we are required to bring to your attention the existence of a
          &apos;Community list&apos; which contains details of air carriers that are subject to an
          operating ban within the EU Community. The Community list is available for inspection at{" "}
          <a
            href="http://ec.europa.eu/transport/modes/air/safety/air-ban/index_en.htm"
            target={"_blank"}
            rel="noreferrer"
          >
            http://ec.europa.eu/transport/modes/air/safety/air-ban/index_en.htm.
          </a>{" "}
          . In accordance with EU Regulations, we are required to advise you of the operating
          carrier(s) (or, if the operating carrier(s) is not known, the likely carrier(s)) that will
          operate your flight(s) at the time of booking. Where we are only able to inform you of the
          likely carrier(s) at the time of booking, we will inform you of the identity of the
          operating carrier(s) as soon as we become aware of this. Any change to the operating
          carrier(s) after your booking has been confirmed will notify you as soon as possible. Any
          change in the airline&apos;s identity, flight timings and/or aircraft type will not
          entitle you to cancel or change to other flight arrangements without paying charges,
          except where specified.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          7.7. Flight times can change for several different reasons. It would be best if you always
          looked to reconfirm your flights 72 hours before departure to ensure that no changes to
          your flight schedule have occurred.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          8. FLIGHT DETAILS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          8.1. Please note details of airlines, flight numbers, and destination airport will be
          clearly shown on your E-ticket or/and confirmation invoice.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          8.2. Please note that no airline can guarantee departure times, and these may change due
          to weather conditions, air traffic control restrictions or technical/operational problems.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          8.3. World Cruise Vibes is not liable for any change to a departure/arrival time
          previously shown on your confirmation. For this reason, you are required to reconfirm your
          flight departure time 72 hours before departure with the airline concerned and complete
          online check-in according to the applicable airline’s procedures.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          8.4. World Cruise Vibes is also unable to make any special arrangements for passengers if
          the flight is delayed as this is the sole responsibility of the carrying airline and/or
          their ground handling agent.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          8.5. Unfortunately, we are unable to guarantee particular aircraft types or seat
          allocation. Flights described as “direct” will not necessarily be non–stop. If you book a
          return journey and do not use the outward flight without contacting the carrier
          immediately, the airline may cancel the return flight without a refund. All flight tickets
          must be used in sequence.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          8.6. Most flight bookings are non-refundable, and any changes or cancellations are subject
          to fees. For more information, check the booking conditions of each airline. Please
          contact us if you need to make any changes or cancel your booking, as we are your booking
          agent.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          9. CHANGES AND AMENDMENTS TO FLIGHT SCHEDULES
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          There are instances where airlines alter the schedules of their flights from time to time.
          This may happen either before you depart or while you are travelling. We strongly advise
          you to check your onward or return flight details at least 72hours before departure.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          10. GDPR STATEMENT
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          10.1. World Cruise Vibes strive to be fully GDPR (General Data Protection Regulation)
          compliant and routinely review our data management policies. We have measures in place to
          protect the personal booking information held by us and passed on to the relevant Service
          Providers of your travel arrangements. These may include public authorities such as
          customs and immigration and security or credit card services.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          10.2. We will only pass on your information to persons responsible for your travel
          arrangements - this may include sensitive information such as details of disabilities and
          dietary or religious requirements. If you travel outside the European Economic Area (EEA),
          controls on data protection may not be as strong as those within the EEA.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          10.3. When making a booking, you consent to the relevant information being passed on as
          above. If you have any questions or concerns about any aspect of our policies regarding
          the capture and processing of your personal data, please refer to the complete Privacy
          Statement on our website:{" "}
          <a
            href="https://www.worldcruisevibes.com/privacy-policy"
            target={"_blank"}
            rel="noreferrer"
          >
            https://www.worldcruisevibes.com/privacy-policy
          </a>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          10.4. Alternatively, you may contact our Data Protection Officer via mail: The Data
          Protection Officer, World Cruise Vibes. 14 Cricklewood Ln, London NW2 1EX, United Kingdom.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          11. FINAL TRAVEL ARRANGEMENTS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          11.1. Please make sure that all of your travel, passport, visa, and insurance
          documentation are in order and that you arrive at the airport in plenty of time to
          check-in. You may need to reconfirm your flight with the airline before leaving.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          11.2. Don&apos;t hesitate to contact us at least 72 hours before your departure flight for
          more information. When reconfirming, make a note of any reference numbers or contact
          names. You may be denied permission to board the plane if you do not reconfirm, and you
          will not be eligible for a refund.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          11.3. It is your responsibility to gather the necessary documents. For example: passports,
          visa for the final destination, transit visa for the transit destination, relevant
          additional paper works like passenger locator form for final and transit destinations.
          Visit the below website for further travel advice and entry requirements for different
          destinations:{" "}
          <a href="https://www.gov.uk/foreign-travel-advice" target={"_blank"} rel="noreferrer">
            https://www.gov.uk/foreign-travel-advice
          </a>{" "}
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          11.4. Prior to departing on a European holiday, you need have a completed and granted EHIC
          form.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          12. SPECIAL REQUESTS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          12.1. Please notify us at the time of booking if you have any specific requests (such as
          food requirements, cribs, or room location). All requests of this kind will be forwarded
          to the supplier, but we cannot ensure that they will be fulfilled, and we will not be
          liable to you if they are not.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          12.2. Kindly note that special requests are highlighted and are usually based on sharing
          beds in the room. If you require a separate bed, this must be requested at the point of
          the booking, as additional charges may apply for extra beds.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          12.3. For special offer meal plans, “Kids Stay and Eat Free” refers to the board basis of
          the complete reservation. Where a booking is for Half Board, the child&apos;s meal plan
          will be half board. We strongly suggest you speak about this with your travel advisor
          or/and refer to your booking confirmation for more details. All our special offers are
          subject to terms and conditions which will be explained to you at the time of booking.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          13. MEDICAL CONDITIONS, PREGNANT WOMEN, UNACCOMPANIED MINORS AND PASSENGERS WITH REDUCED
          MOBILITY TRAVELLING
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          13.1. In some cases, some destinations may not be suitable for those who use a wheelchair
          or lack mobility. If any member of your party has any medical condition or disability
          which may affect your booking, please notify us before you make your booking so that we
          can try to confirm the suitability of your chosen arrangements. Regrettably, if you do not
          advise us in full prior to making your booking, it may limit your rights under the Package
          Travel and Linked Travel Arrangements Regulations 2018. On occasions, some Service
          Providers may request the completion of a medical form or a letter from a GP confirming
          fitness to travel.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          13.2. <b>Pregnant women </b>- Most airlines will not let you fly after week 37 of
          pregnancy or week 32 if you&apos;re pregnant with twins or more babies. They may request
          the completion of a medical form or a letter from a GP confirming fitness to travel. For
          more information, please visit:{" "}
          <a href="https://www.nhs.uk/" target={"_blank"} rel="noreferrer">
            Travelling in pregnancy - NHS (www.nhs.uk)
          </a>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          13.3. <b>Unaccompanied minors </b> - Any passenger aged 5 to 18 travelling without an
          adult is considered an accompanied minor. Airlines frequently require additional
          documentation for children travelling unaccompanied, and therefore this must be informed
          to us ahead of time. We will not be held liable for any refusal to embark or delays due to
          a lack of required documents. Before booking, you should check the airline&apos;s policy
          on children travelling unaccompanied.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          13.4. <b>Passengers with reduced mobility </b> -Travel rights for people with reduced
          mobility vary significantly depending on which airline is chosen and the flight&apos;s
          destination. Please let us know if you or anybody else in your party has reduced mobility
          before making a booking with us so that we can determine if the holiday package is
          appropriate for you.
          <br />
          <br />
          For more information about how to assist special assistance and your rights in air travel
          please visit:
          <a
            href="https://www.caa.co.uk/Passengers/PRM/Passengers-with-disabilities-and-reduced-mobility/"
            target={"_blank"}
            rel="noreferrer"
          >
            https://www.caa.co.uk/Passengers/PRM/Passengers-with-disabilities-and-reduced-mobility/
          </a>
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          14. CHANGES OR CANCELLATIONS BY THE SERVICE PROVIDER
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          14.1. We will notify you of any changes or cancellations as soon as reasonably possible.
          If the Service Provider provides alternative arrangements or a refund, you will need to
          let us know your choice within the time frame we specify. If you fail to do so, the
          Service Provider is entitled to assume you wish to accept the alternative option provided.
          We will not be held responsible for any changes or cancellations made to your arrangements
          by the Service Provider under your contract with them.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          15. AMENDMENTS BY YOU
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          15.1. Any amendments to your Travel Service will incur an administration charge per
          booking and any charges imposed by the Service Provider. No modifications can be made less
          than 5 working days prior to departure. These charges include but are not limited to:
        </Typography>
        <Typography component={"ul"}>
          <li>Change of destination</li>
          <li>Change of hotel</li>
          <li>Change of name</li>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          15.2. In the event that you request to amend your booking, please click here to submit
          your request through{" "}
          <Box
            sx={{
              color: "primary.main",
              display: "inline-block",
              cursor: "pointer",
            }}
            // onClick={() => setOpenBookingRefModal(true)}
          >
            &apos;Manage My Booking&apos;
          </Box>
          .
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          15.3. We, the travel agent, will not be able to make any changes to your booking with a
          Service Provider ourselves, nor will we be able to confirm if a Service Provider will make
          the amendments you have requested.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          15.4. Amendments to your Travel Service can only be made in accordance with the terms and
          conditions of the Service Provider(s), which you shall receive at the time of booking. The
          Service Provider may charge amendment charges which may be as much as 100% of the cost of
          the Travel Service.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          15.5. While booking your hotel room or service, you may be able to select special rates
          which are non-refundable, non-changeable and non-transferable. This indicates that no
          changes whatsoever, including names, dates, and duration, can be made from the time the
          booking is confirmed, and the only option available is to cancel.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          15.6. All amendment charges are subject to change at any time. Please remember that
          amendments/revision fees are non-refundable and can only be queried by the lead passenger
          on the booking.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          15.7. You should be aware that many Service Providers do not allow a free transfer and
          treat it as a cancellation and rebooking (at current prices), for which there is a 100%
          cancellation charge.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          15.8. Some Service Providers may provide precedence to other customers for cancelled
          arrangements. We will do our best to secure a suitable alternative so that the Package can
          continue and be transferred to the new person. You will need to give us reasonable notice
          of this change, but 7 days or more before departure is considered reasonable.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          16. CANCELLATIONS BY YOU
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          16.1. You can revoke your booking at any time before departure upon payment of a
          cancellation/termination fee. By accepting these terms & conditions, you are providing
          authority for us to automatically charge the payment card used by you when obtaining the
          booking or any other card used in connection with this booking.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          16.2. Please note that any cancellation will incite a cancellation processing fee,
          including any charges from the Service Provider(s).
          <br />
          <b>Flight: </b>
          Please note that the value of the flights is 100% non-refundable from the point of booking
          as well as baggage, insurance, etc.
          <br />
          <b>Accommodation:</b> The charge will depend on whether you have booked a refundable or a
          non-refundable product for cancellations. Cancellation charges will be described to you at
          the time of booking and modified from one Service Provider to another. Therefore, you must
          go through your Booking Confirmation and any documentation for details of your
          cancellation terms. Non-refundable products may have been paid in full at the time of
          booking, and no refunds are available in the event of cancellation.
          <br />
          <b>Transfers:</b> The value of transfers is 100% non-refundable from the point of booking.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          16.3. Every request made to cancel must be submitted via{" "}
          <Box
            sx={{
              color: "primary.main",
              display: "inline-block",
              cursor: "pointer",
            }}
            // onClick={() => setOpenBookingRefModal(true)}
          >
            “Manage My Booking”
          </Box>
          , which is where you will be made aware of any cancellation charges, and you are obligated
          to agree to these charges in order to proceed with the cancellation.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          16.4. If upon cancellation you would like to claim back the tax on your flight, please
          note that:
        </Typography>
        <Typography sx={{ mb: "1rem" }} component={"ul"}>
          <li>
            If you made a flight booking with a world cruise or self-service airline, for example,
            EasyJet, Norwegian, TUI etc., we will contact the airline directly on your behalf to
            request the refund. We will refund any such amounts received by us from the airline
            following its receipt.
          </li>
          <li>
            Some low-cost airlines might require passengers to contact them directly regarding
            refunds. In this case, we will let you know so you can request the refund directly from
            them.
          </li>
          <li>
            If you made a flight booking with one of the scheduled airlines, for example, British
            Airways, Virgin Atlantic, Emirates etc., or if we booked the flight for you on your
            behalf, we&apos;d request a refund of the flight tax. Please contact us so that we can
            make this happen for you.
          </li>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          16.5. In the event of unavoidable and extraordinary circumstances, as described in clause{" "}
          <b>&quot;Unavoidable and Extraordinary Circumstances,&quot;</b> occurring at the place of
          destination or its immediate region, in addition to the cancellation rights set out above,
          you shall have the right to cancel your booking before the start of the Package without
          paying any cancellation charge. . If you cancel in these circumstances, we shall provide
          you with a full refund of any payments made concerning your booking, yet, you will not be
          entitled to compensation or any of the rights set out in clause 19 below.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          16.6. We ask that you please visit the Foreign, Commonwealth & Development Office&apos;s
          (&quot;FCDO&quot;) website to review the latest travel advice about your holiday
          destination.{" "}
          <a href="https://www.gov.uk/foreign-travel-advice" target={"_blank"} rel="noreferrer">
            https://www.gov.uk/foreign-travel-advice
          </a>{" "}
          Please note that when deciding whether or not the cancellation rights described in the
          paragraph above have arisen, we consider the FCDO&apos;s advice.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          16.7. The lead passenger (person who made and paid for the booking) for your party may
          only cancel your travel arrangements at any time. Written notification must be received by
          the person who made the booking via email;{" "}
          <a href="mailto:info@worldcruisevibes.com" target={"_blank"} rel="noreferrer">
            info@worldcruisevibes.com.
          </a>{" "}
          Since we incur costs in cancelling your travel arrangements, you will have to pay the
          applicable cancellation charges.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          17. IMPORTANT NOTICE ON FCDO ADVICE AGAINST ALL OR ALL BUT ESSENTIAL TRAVEL AS A RESULT OF
          THE COVID-19 PANDEMIC
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          17.1. The Foreign and Commonwealth Office (FCO) is advising UK travellers against all but
          essential travel to several destinations as a result of the COVID-19 pandemic. The FCO
          Advice is updated regularly and often at very short notice. It is possible that by the
          time you depart for your holiday, the FCO will advise against non-essential travel.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          17.2. If FCO Advice applies to your holiday destination at the time of your departure,
          your Service Providers can still provide the Travel Services in the Package. The
          performance of your Package is not significantly affected. Your usual cancellation rights
          in the event of Unavoidable and Extraordinary Circumstances (as described above) will not
          apply.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          17.3. We may disapply these cancellation charges if, at the time you made your booking,
          the FCO Advice did not apply to your holiday destination. In such cases, we may provide
          you with a refund for the hotel and transfer services. If the airline&apos;s cancellation
          policy includes a full/partial cash refund or a credit voucher, we will issue this to you
          as soon as we receive it from the airline.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          17.4. There may be an instance where we offer you options for a cash refund, for example,
          a refund credit note or voucher, which allows you to travel on another date. Should we
          offer such options, they shall be offered additionally to your rights. We will let you
          know if you have these further options when we inform you about your cancellation
          arrangements.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          18. CHANGES AND CANCELLATIONS TO YOUR TRAVEL SERVICE
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          18.1. We and the Service Providers reserve the right to make changes to your Travel
          Services at any time. Most changes are minor, and we will attempt to pass them on to you
          prior to your departure. Apart from providing such notification, we shall have no further
          liability for minor changes.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          18.2. A minor change made prior to your departure could consist of the change of your
          outward or return flight by less than 12 hours, changes to carriers such as airlines,
          changes to aircraft or vehicle type, change of your accommodation to another of the same
          or better standard with the same main features and in the same resort destination or
          changes of services available at your accommodation.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          18.3. Significant changes made before your departure could include a change of
          accommodation to a different area of the city, a change of accommodation to that of a
          lower standard/star rating for the whole or a significant part of the time you are on
          holiday, a change of your outward flight departure time (or the commencement of your other
          Travel Services) by more than 12 hours, or a change of UK departure airport, except
          between:
        </Typography>
        <Typography sx={{ mb: "1rem" }} component={"ul"}>
          <li>London Airports: Gatwick, Heathrow, Luton, Stansted, London city and Southend.</li>
          <li>South Coast Airports: Southampton, Bournemouth, and Exeter.</li>
          <li>Southwestern Airports: Cardiff and Bristol.</li>
          <li>Midlands Airports: Birmingham, East Midlands, and Doncaster Sheffield.</li>
          <li>
            Northern Airports: Liverpool, Manchester, Doncaster Sheffield, and Leeds Bradford.
          </li>
          <li>Northeastern Airports: New Castle and Teesside.</li>
          <li>Scottish Airports: Edinburgh, Glasgow, Prestwick, and Aberdeen.</li>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          18.4. In relation to Package bookings only, in the unlikely event that your Service
          Providers or we have to make a substantial change to your Package, we will tell you as
          soon as reasonably possible. You will then have the option to:
        </Typography>
        <Typography sx={{ mb: "1rem" }} component={"ul"}>
          <li>
            Accept the proposed change. If this results in a Package of lower quality or cost, you
            may be entitled to a price reduction according to clause 19 below;
          </li>

          <li>
            Reject the proposed change, terminate your Package, and take a different one if we
            decide to offer this. If you decide to take a different Package, we will notify you of
            its impact on your booking price. If the alternative Package is of a lower quality or
            cost, you may be entitled to a price reduction in accordance with clause 19 below, or
          </li>

          <li>
            We will give you a reasonable period of time to make your decision, which will depend
            upon the circumstances giving rise to the change. If we do not hear from you within this
            timeframe, we will send a reminder to you. This may include us terminating the Package
            and providing you with a refund.
          </li>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          18.5. You may be entitled to compensation due to our cancellation of your Package in
          accordance with clause 19 below, except where we are prevented from providing the Package
          because of Unavoidable and Extraordinary Circumstances, and we notify you of the
          cancellation without undue delay before the start of your Package.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          18.6. Concerning cancellations made due to global travel disruption arising from the
          COVID-19 outbreak, we may offer you alternatives to a cash refund, such as a refund credit
          note or voucher, which will allow you to travel at another date. If we offer such options,
          they shall be offered in addition to your rights set out above. We will let you know if
          you have these additional options when we notify you about the cancellation of your
          Package.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          19. PACKAGE BOOKINGS: PRICE REDUCTION AND COMPENSATION FOR DAMAGES
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          19.1. You will be eligible to receive suitable compensation from us for any damage you
          endure as a result of a failure except where the failure is:
        </Typography>
        <Typography sx={{ mb: "1rem" }} component={"ul"}>
          <li>Attributable to you;</li>

          <li>
            Attributable to a third party unconnected with the provision of the Travel Services
            included in the Package and is unforeseeable or unavoidable; or
          </li>

          <li>Due to Unavoidable and Extraordinary Circumstances.</li>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          19.2. We will not be liable to pay compensation if there are international conventions
          which limit the extent or conditions under which compensation would have to be paid by one
          of the Service Providers. These international conventions include (but are not limited to)
          the Montreal Convention in respect of travel by air (and all earlier related conventions),
          the Athens Convention in respect of travel by sea, the Berne Convention in respect of
          travel by rail (Convention concerning International Carriage by Rail (COTIF) of 9 May
          1980), the Geneva Convention in respect of travel by road and the Paris Convention in
          respect of the provision of accommodation. We shall have the full benefit of any
          limitation of compensation contained in these conventions and any other international
          conventions that govern the travel arrangements that make up the Package.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          19.3. Our liability shall be limited in accordance with the contractual conditions of the
          Service Providers that offer the transportation component of your Package Holiday, in the
          same way, that such limitations would apply directly to us.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          19.4. Except in the circumstances involving death, injury, or disease caused by the
          Service Providers or us negligently, our liability to you in connection with your Package
          is limited to three times the cost of your Package.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          19.5. Apart from the foregoing, we disclaim all obligations for any claims, losses,
          expenditures, damages, or liability arising from your Package, except in circumstances of
          death, injury, or disease caused by our carelessness.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          19.6. Unless the failure is attributable to you, for any period during which there is a
          failure, you will be entitled to a reasonable price reduction.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          20. OUR SERVICE CHARGES
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          20.1. <b>Applicable charges.</b> <br />
          Admin fee - £50 <br />
          *Please note that service charge, cancellation and amendment fees are non-refundable.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          21. OUR RESPONSIBILITY FOR YOUR BOOKING
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          <b>
            <u>Non-package bookings</u>
          </b>{" "}
          <br />
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.1. We accept no responsibility as an agent for the actual delivery of the Travel
          Service. Our responsibilities are limited to the booking service we provide. We pass on
          information in good faith if any faults in that information are beyond our control (e.g.,
          because they are mainly due to the error/fault of the Service Provider).
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.2. We are not responsible for any damage or loss that is not predictable. Loss or
          damage is predictable if either it is obvious that it will happen or if, at the moment you
          entered the contract, both you and we recognised it might happen. We only source our
          services for domestic, non-commercial, and private use.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.3. We also agree to take no responsibility for the conduct or actions of third parties
          connected to your accommodation, transfer, or flight, or for any facilities/services
          withdrawn as a result of their actions.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.4. If we are liable to you in any way whatsoever, our all-out liability to you is
          limited to two times the cost of your affected Travel Services.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          <b>
            <u>Package bookings</u>
          </b>{" "}
          <br />
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.5. We have a liability to you for the performance of the Travel Services included in
          your Package booking under the Package Travel Regulations, irrespective of the fact that
          such Travel Services have to be achieved by the Service Providers or the principal
          suppliers.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.6. However, you must let us know instantly of any failure or unfitting performance of
          your Travel Service (&quot;Failure&quot;). This will allow us to resolve the Failure while
          you are on holiday. If we cannot do so, or if it is impossible to rectify the Failure
          immediately, you may resolve it yourself and request reimbursement from us.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.7. Kindly note that the actions set out in clause 4 is required to manage the risks of
          COVID-19 as part of a standard safety management system. By making a booking with us, you
          agree that their existence shall not be considered as any form of Failure.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.8. We will offer a suitable alternative arrangement with no cost to you for the
          continuation of the Package. Where possible, these alternative arrangements shall be of
          equal or higher quality than those specified in your booking. You will be entitled to a
          price reduction as described in clause 19, where they are of lower quality.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.9. You may decide to continue with your Package or dismiss your booking without paying
          a termination fee. If your Package included carriage to the destination, we will also
          repatriate you with equal transport back to your place of departure. You may, where
          appropriate, be entitled to a price reduction and/or compensation in accordance with
          clause 19.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.10. We will provide you with information on health services, local authorities and
          consular assistance. We do not charge for this assistance, while we reserve the right to
          charge a reasonable fee for such assistance if the difficulty has been caused
          intentionally by you or a member of your party or through your negligence or misconduct.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          21.11. We advise you to obtain travel insurance on all-inclusive holidays as a best
          practice as coverage for sudden illnesses, damages, food poisoning, loss of luggage and
          money etc.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          22. “NO SHOWS”
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          22.1. A confirmed booking which is made for any travel service including flights, car
          hire, accommodation and packages but is not used, (for example, you fail to check-in for
          your flight /accommodation or collect your rental vehicle) refunds may not be offered, and
          cancellation charges of up to 100% may be applied by the relevant Service Provider.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          22.2. A refund of the departure tax of your flight component may be refunded according to
          the airline policies.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          23. CREDIT CARDS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          23.1. It is compulsory that you or a member of your party travel with a recognised credit
          card as some Travel Service providers may request you to pay a deposit (including, but not
          limited to, at hotel check-in/car hire collection, the level of deposit required will
          differ by Travel Service Provider).
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          23.2. Your Travel Service Provider may process an authorisation request to the relevant
          credit card provider and/or hold a sum on the applicable credit card to cover any monies
          payable at the end of your stay for this purpose (including, but not limited to, charges
          for room service, mini bar items, fuel deficit and city or other taxes).
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          23.3. The relevant credit card provider may charge a fee for international transactions
          and/or apply a foreign currency conversion fee. Please check with the relevant credit card
          provider for further information on the types of fees it charges.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          24. TAXES/ LOCAL CHARGES AND RESORT FEE
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          24.1. Including all departure/city taxes on your ticket/hotel is not always possible. In
          some cases, departure taxes/city taxes must be paid locally, and these are payable to the
          government of the country you are visiting and are non-refundable.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          24.2. Certain countries/cities/airports/hotels impose additional taxes and charges such as
          departure, tourist or city tax, facility fees or compulsory resort fees. These additional
          fees are payable directly to your accommodation or local authorities and are for the
          maintenance of local facilities and services.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          24.3. Your Service Providers or we cannot collect these taxes in advance. You are solely
          responsible for paying these taxes and charges locally prior to checking out at the hotel,
          and it is subjected to change by a declaration of relevant governments. Airport departure
          taxes (under various names) are included in most air tickets priced by airlines.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          24.4. Nevertheless, some countries will charge an additional local tax when you depart the
          country. Unless otherwise mentioned, they are not included in your booking. Please enquire
          with us prior to booking for further clarifications. We are not liable to you for these
          taxes or charges, and they are not included in your booking.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          25. DELIVERY OF DOCUMENTS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          25.1. All documents (e.g., invoices/tickets/insurance policies) will be sent to you by
          email after 72 working hours of completion of your booking. In some instances, it may take
          longer to issue certain tickets due to the booking conditions of your flight or other
          services. Our travel advisors will inform you of such instances, and your e-tickets will
          be sent to you as soon as the Service Provider issue them to us.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          25.2. We may charge you documentation and admin/postal fee if you request your tickets via
          mail.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          25.3. Once your travel documents leave our office, we will not be responsible for their
          loss unless such loss is due to our negligence. You may have to pay any charges made by
          Service Providers if tickets or other documents need to be reissued.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          26. INSURANCE
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          26.1. Adequate travel insurance is a requirement of your contract with the relevant
          provider or us, as the case may be. To protect yourself and your group against costs such
          as cancellation, help in the event of an accident or illness, loss of luggage and money,
          and other expenses, you must get travel insurance.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          26.2. If your insurance has been issued, please review it carefully to confirm that all of
          the contents are right and that you have provided all required information (e.g.,
          pre-existing medical conditions). Your insurance will be affected if you fail to report
          pertinent facts. We shall not be liable for any losses for which insurance protection
          would otherwise be available if you do not travel with proper insurance coverage.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          26.3. Most insurances may not cover COVID-19 related medical conditions or losses incurred
          due to the same. We strongly recommend you inquire about your insurance needs before
          confirming and purchasing your insurance with us or any other service provider.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          26.4. We advise you to obtain travel insurance on all-inclusive holidays as a best
          practice as coverage for sudden illnesses, damages, food poisoning, loss of luggage and
          money etc.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          27. UNAVOIDABLE AND EXTRAORDINARY CIRCUMSTANCES
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          27.1. Unless specified in these booking conditions, we will not be liable or compensate
          you if our duties to you are affected by events that the service provider is in issue, or
          we could not have avoided despite taking all reasonable precautions.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          27.2. War, the threat of war, civil strife, terrorist activity and its implications or the
          danger of such action, riot, the act of any government or other national or local
          authority, industrial dispute, natural or nuclear disaster, fire, chemical or biological
          disaster, weather conditions that makes it impossible to travel safely to the destination,
          and all other events beyond our or the supplier&apos;s control are examples of these
          events.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          28. COMPLAINTS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          28.1. As a strict condition of booking a holiday with us, you must obtain a written record
          of your complaint from the Service Provider or their representative at the time the issue
          arose. If you are unable to speak to the Service Providers whilst on holiday, you should
          contact our Travel Consultants. You may also email us at{" "}
          <a href="mailto:complaints@worldcruisevibes.com" target={"_blank"} rel="noreferrer">
            complaints@worldcruisevibes.com.
          </a>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          28.2. Please notify us of your complaint within 28 days of your return from vacation. If
          you do not do so, the Service Provider or we will have fewer opportunities to investigate
          and resolve your complaint. As a result, any compensation you may be entitled to may be
          reduced or eliminated.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          28.3. If you expect to complain when you return home, please send a detailed complaint
          through our &apos;Post Travel Query&apos; form in the My Holiday Details section of{" "}
          <Box
            sx={{
              color: "primary.main",
              display: "inline-block",
              cursor: "pointer",
            }}
            // onClick={() => setOpenBookingRefModal(true)}
          >
            &apos;Manage My Booking&apos;
          </Box>
          , including your written report from the Service Provider or their representative or any
          additional documentation supporting your claim.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          29. ALTERNATE DISPUTE RESOLUTION
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          29.1. Suppose we cannot resolve a dispute informally. In that case, we will discuss the
          most effective method of resolving the dispute, which may include mediation or
          arbitration, depending on the nature of the dispute.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          29.2. You could also access the European Commission Online Dispute Resolution (ODR)
          platform at{" "}
          <a href="http://ec.europa.eu/consumers/odr/" target={"_blank"} rel="noreferrer">
            http://ec.europa.eu/consumers/odr/.
          </a>{" "}
          This ODR platform is a means of reporting your complaint with us. It will not determine
          how your complaint should be resolved.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          30. TRAVEL ADVICE, PASSPORTS, VISAS AND HEALTH REQUIREMENTS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.1. We recommend you always look at the Foreign Travel Advice section of the Foreign,
          Commonwealth & Development Office (FCDO) website prior to booking and travelling abroad.
          Visit Foreign, Commonwealth & Development Office website to check your general visa,
          passport, health and safety information and other matters prior to booking.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.2. You confirm that all members of your party are the UK or Irish residents and hold
          passports valid for at least 6 months after the duration of the Travel Service you chose
          to purchase. General information on visa, passport, and health requirements (where given
          and applicable) is given solely on this basis.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.3. Some of our Service Providers offer their low rates on the basis that customers are
          residents in the UK and/or Ireland, and citizens of the country where the stay is taking
          place may not be eligible to stay at that particular rate. This does not apply to citizens
          of EU countries staying in other EU countries in most circumstances. However, issues may
          occur when customers are booked to stay in the country where the passport was issued. For
          example, Turkish nationals in Turkey or Egyptian nationals in Egypt.
          <br />
          We cannot be held responsible for any additional costs incurred due to these issues.
          Service Providers may ask that we contact you prior to the departure date to ask for
          evidence of the residency of the customers travelling. You must contact our Travel
          Consultants in this instance within the stated timeframe with this information.
          <br />
          For further information about passports, go to{" "}
          <a
            href="https://www.gov.uk/browse/citizenship/passports"
            target={"_blank"}
            rel="noreferrer"
          >
            https://www.gov.uk/browse/citizenship/passports
          </a>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.4.<b> Transit visas:</b> For transiting through a country with connecting flights, a
          transit visa is necessary in several countries. If a transit visa is required for your
          trip, we will let you know. For the most up-to-date information on visa entrance
          requirements, visit the UK government&apos;s foreign travel website.{" "}
          <a href="https://www.gov.uk/foreign-travel-advice" target={"_blank"} rel="noreferrer">
            https://www.gov.uk/foreign-travel-advice
          </a>{" "}
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.5. An ESTA visa is required for all travel to and from the United States, as well as
          transiting the country; an ETA visa is required for all travel to and from Australia, as
          well as transiting the country. Please check if your flight has a path change that
          involves two different airports; it is your responsibility to arrange for a transfer to
          the relevant airport and, if necessary, a transit visa. Travel to the United States is
          subject to special rules, and all passengers must have their own machine-readable
          passports. Please check{" "}
          <a href="https://uk.usembassy.gov/" target={"_blank"} rel="noreferrer">
            https://uk.usembassy.gov/
          </a>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.6. Prior to departing on a European holiday, you need have a completed and granted EHIC
          form.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.7.{" "}
          <b>
            * Please be aware that if you are a United States citizen, tourist travel to Cuba
            remains prohibited. To travel to Cuba, you must obtain a licence from the US Department
            of Treasury, or your travel must fall into one of the 12 categories of authorised
            travel.
          </b>
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.8.{" "}
          <b>
            Please make sure to apply for Electronic Travel Authorisation (ETA) when travelling to
            Australia or Canada or travelling via Australia or Canada.
          </b>{" "}
          For further information please contact us as we can assist in the application.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          30.9. When travelling to New Zealand, a new travel requirement has been imposed for some
          visitors and transit passengers.{" "}
          <b>
            Passengers must apply for The New Zealand electronic travel authority (NZeTA) before
            departure.
          </b>{" "}
          Its approval can take upto 72 hours.{" "}
          <b>
            It is important to note that valid documentation is required before boarding your flight
            to New Zealand.
          </b>{" "}
          Passengers may be denied boarding if they do not hold a valid NZeTA for travel to New
          Zealand.
          <br />
          Please visit the New Zealand government website for more information:{" "}
          <a
            href="https://www.immigration.govt.nz/new-zealand-visas/apply-for-a-visa/about-visa/nzeta"
            target={"_blank"}
            rel="noreferrer"
          >
            https://www.immigration.govt.nz/new-zealand-visas/apply-for-a-visa/about-visa/nzeta
          </a>
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          31. ACCOMMODATION RATINGS AND STANDARDS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          31.1. After registering/checking in at your accommodation, you will be assigned a room.
          You must confirm the check-in and check-out times with the Service Provider directly.
          Please keep in mind that just because rooms are listed together on the same booking
          itinerary doesn&apos;t mean they&apos;ll be next to each other or otherwise close.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          31.2. These requests are not guaranteed; nevertheless, you should check with the
          accommodation reception/front desk at the time of check-in or contact them at least 72
          hours before check-in to make sure. If these requests are not approved, World Cruise Vibes
          will not be held liable for any requests turned down.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          32. BAGGAGE ALLOWANCE
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          32.1. The amount of free baggage supplied to passengers varies significantly from airline
          to airline and route to route. The regular baggage allowance given by the airline is
          included in our rates. Your airline&apos;s booking rules will specify the allowance you
          are entitled to. Some airlines may enable you to add more luggage after you&apos;ve made
          your reservation; this depends on the rules and restrictions of the specific airline you
          should consult.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          32.2. When flying with an airline that charges for keeping luggage, it is not included or
          displayed in our headline costs. You will be given the option to purchase this extra
          service at the time of booking. Should you choose not to take any hold luggage on your
          trip, you will receive the standard hand luggage allowance as detailed in the airline
          booking conditions.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          32.3. For further information, please refer to the airline booking conditions. Please note
          that baggage allowance for specific Visual Flight Rules, Promotional and Tour fares can
          differ. Please refer to your booking confirmation for your confirmed baggage allowance.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          33. ROOM ALLOCATION
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          33.1. After registration, you will be assigned a room when you arrive at your
          accommodation. You must confirm the check-in and check-out timings with your accommodation
          provider directly. Any local taxes and penalties must be paid to your hotel provider in
          advance at check-out.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          33.2. We do not guarantee these requests; however, we encourage you to check with the
          accommodation reception/front desk at the time of check-in or contact them at least 72
          hours before check-in to be sure. If these requests are not accepted, World Cruise Vibes
          will not be liable for such denied requests.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          Some hotels have certain regulations that operates on a per-room basis. Please note that
          according to these regulations, you will not be permitted to use some hotel amenities such
          as restaurants, swimming pools, play areas etc.
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          34. BUILDING WORK
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          34.1. At a hotel, renovations and refurbishments and the noise they cause are unavoidable
          from time to time. If we become aware of such works, we will notify you before you make
          your reservation or within a reasonable time after we become aware of them.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          35. INSOLVENCY PROTECTION
        </Typography>
        {/* <Typography sx={{ mb: "1rem" }}>
          35.1. We provide complete financial protection for our flight-inclusive Package, and ATOL
          protected flight-only sales by way of our Air Travel Organiser&apos;s Licence number 10336
          issued by the Civil Aviation Authority, Gatwick Airport South, West Sussex, RH6 0YR, UK,
          telephone{" "}
          <a href="tel:+44 (0)333 103 6350" target="_blank" rel="noreferrer">
            +44 (0)333 103 6350
          </a>
          , email{" "}
          <a href="mailto:claims@caa.co.uk" target={"_blank"} rel="noreferrer">
            claims@caa.co.uk
          </a>
        </Typography> */}
        <Typography sx={{ mb: "1rem" }}>
          35.1. You will obtain an ATOL Certificate when you purchase an ATOL-protected flight or
          flight-inclusive package from us. This section explains what is financially covered, where
          you can receive further information, and who to contact if you need to file a claim.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          35.2. In some cases, an alternative ATOL holder may provide you with the services you have
          bought or a suitable option (at no extra cost to you). You agree to pay any outstanding
          money to be paid by you under your contract to that alternative. In these cases, you will
          be entitled to claim under the ATOL scheme or your credit card issuer where applicable.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          35.3. If we, or the suppliers named on your ATOL certificate, become insolvent, we will be
          unable to offer the services listed (or a suitable alternative, via another ATOL holder or
          otherwise). The Trustees of the Air Travel Trust may pay you (or provide you with a
          benefit) under the ATOL scheme in that case.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          35.4. You agree that in exchange for such a payment or benefit, you will assign to those
          Trustees any and all claims you may have arising out of or related to the non-provision of
          services, including any claim against us, the travel agent (or your credit card issuer
          where applicable).
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          35.5. You further accept that any such claims may be allocated to another body if that
          other body has paid the ATOL scheme monies you have claimed.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          36. CHARGEBACKS AND CLAIMS AGAINST SERVICE PROVIDERS
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          36.1. Unless such rights have arisen under section 75 of the Consumer Credit Act 1974, you
          agree not to issue any chargebacks or otherwise dispute transactions with your payment
          card issuer against us (“Chargeback”). Rather, your rights to refunds and other claims
          shall be governed solely by these Terms and Conditions.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          36.2. You agree that if you initiate a Chargeback (including under section 75) or make a
          demand for payment from a Service Provider (which may be satisfied by the payment of cash,
          issue of vouchers or as otherwise agreed between you and the Service Provider) we shall be
          entitled to take such steps as we consider reasonable to ensure that you are not paid
          twice for the same claim.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          37. BREXIT
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          37.1. For the purposes of these Terms and Conditions, “Force Majeure” means any event
          beyond our or the Service Provider&apos;s control, the consequences of which could not
          have been avoided even if all reasonable measures had been taken.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          37.2. Certain Travel Services may be affected due to the United Kingdom&apos;s decision to
          leave the European Union and the end of the transition period relating to Brexit. This can
          include unavailability of some flight routes, problems with access to certain ports and
          airports and changes to the visa requirements of British citizens travelling to, within or
          through European Union Member States.
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          37.3. While we will monitor the situation, if we become aware of any bookings that will be
          affected by such measures, as all such measures are outside our control, we would treat
          any such changes as Force Majeure. We will endeavour to provide suitable alternative
          arrangements or refunds where possible, and we will not be liable to pay any compensation.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          38. ENTIRE AGREEMENT
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          38.1. The Terms and Conditions set in the complete agreement and understanding between you
          and us in connection with your booking supersede any prior representations, agreements,
          conditions, negotiations, and undertakings made orally or in writing.
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: "1rem" }}>
          39. LAW AND JURISDICTION
        </Typography>
        <Typography sx={{ mb: "1rem" }}>
          39.1. The Terms & Conditions are governed by English law. Any dispute or issue arising
          from these Terms and Conditions must be resolved by the English and Welsh courts (unless
          you live in Scotland or Northern Ireland, bring proceedings to your local court under
          Scottish or Northern Irish law, as applicable).
        </Typography>
        <Typography sx={{ mb: "1rem", mt: "1rem" }}>
          These Terms & Conditions are applicable from 6 October 2020. Registered office address: 14
          Cricklewood Ln, London NW2 1EX, United Kingdom.
        </Typography>
      </Box>

      {/* <ManageBooking
        open={openBookingRefModal}
        handleClose={() => setOpenBookingRefModal(false)}
      /> */}
    </>
  );
};

export default TermsAndCondition;
